import { SongStatusType } from 'types/song';

export const timeSignatures = ['3/4', '4/4', '5/4', '6/8', '7/8', '12/8'];

export const timeSignatureOptions = timeSignatures.map((signature) => ({
  title: signature,
  value: signature,
}));

export const noteValues = ['1', '2', '4', '8', '16', '32', '64'];

export const TEST_STATES = {
  languageCodes: { en: { name: 'English', key: 'en' } },
  songValidationSchema: {
    title: {
      minLength: 1,
      maxLength: 255,
    },
    altTitle: {
      minLength: 1,
      maxLength: 255,
    },
    displayArtistName: {
      minLength: 1,
      maxLength: 255,
    },
    status: {
      enum: SongStatusType,
    },
    language: {
      enum: ['en', null],
    },
    keySignature: {
      enum: ['AFlatMajor', null],
    },
    timeSignature: {
      pattern: '^([1-9][0-9]?/(1|2|4|8|16|32|64))$',
      type: ['string', 'null'],
    },
    tempo: {
      minimum: 5,
      maximum: 990,
      min: 5,
      max: 990,
    },
    duration: {
      minimum: 1,
      maximum: 86400,
      min: 1,
      max: 86400,
    },
    explicit: true,
    notes: {
      minLength: 1,
      maxLength: 1024,
    },
    location: {
      properties: {
        address: {
          minLength: 1,
          maxLength: 500,
        },
      },
    },
    genres: {
      items: {
        properties: {
          genre: {
            enum: ['Pop'],
          },
        },
      },
    },
  },
};
